import { useHistory } from "react-router-dom";
import { useCompanyId, usePlatformUrls } from "./core";
import { Button } from "semantic-ui-react";
import { getCompanyHome } from "./assets-management/config";
import { authStorage } from "./auth";

export function MainMenu() {


  const currentUser = authStorage.getUser();

  const isAdmin = currentUser.isAdmin();
  const history = useHistory();
  let companyId = useCompanyId();
  let { assetsManagement, psAdminDashboard, dealManagement, pfaTool, projectPricingTool } = usePlatformUrls();
  let redirectionUrl = '';
  if (!companyId) {
    const company = authStorage.getCompany();
    redirectionUrl = getCompanyHome(company.id,
      company.amProjectId ?? 'DEMO');
  }

  const isRevStarUser = currentUser.email.endsWith("@revstarconsulting.com");

  //Todo: Hacky code, need to fix this
  return <div>
    <Button onClick={() => history.push(redirectionUrl || assetsManagement())}>Asset Management</Button>
    {(isAdmin || isRevStarUser) && <Button onClick={() => history.push(redirectionUrl || dealManagement())}>Deal Management</Button>}
    {isAdmin && <Button onClick={() => history.push(pfaTool())}>PFA Tool</Button>}
    {isAdmin && <Button onClick={() => history.push(projectPricingTool())}>Project Pricing Tool</Button>}
    {isAdmin && <Button onClick={() => history.push(psAdminDashboard())}>PS Admin Dashboard</Button>}
  </div>

}